import { render } from "./ConfirmSwapModal.vue?vue&type=template&id=5e97a593"
import script from "./ConfirmSwapModal.vue?vue&type=script&lang=ts"
export * from "./ConfirmSwapModal.vue?vue&type=script&lang=ts"
script.render = render

export default script